import React, { useEffect, useState, useRef} from 'react'
import Modal from 'react-modal'
import { renderTextField, renderButton, renderCancelButton} from '@/shared/FormUtils'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'
import { Stack } from '@mui/material'
import Cookies from 'universal-cookie'
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { dataURItoBlob } from '@/utility/FileUtils'

const ItemImageModal = ({
  item,
  open,
  onClose,
  onSave,
  formikProps,
  user,
  id,
  itemImage,
  currentImageCount
}) => {
  isEditing = !!itemImage
  const [ attachmentFile, setAttachmentFile ] = useState(null)
  const [ imagePreview, setImagePreview ] = useState(itemImage?.image)
  const [ submitting, setSubmitting ] = useState(false)
  const [ isCropping, setIsCropping ] = useState(false)
  const [ cropperUrl, setCropperUrl ] = useState(null)
  const cropper = useRef(null)
  const onDrop = async (acceptedFiles) => {
    if(!submitting) {
      if(!acceptedFiles[0]) return
      if(acceptedFiles[0].type.indexOf("image") === -1) {
        alert("The file you uploaded is not an image")
        return
      }
      //If webp conver
      if(acceptedFiles[0].type.indexOf("webp") !== -1) {
        alert("WebP files are not supported. Please upload a JPEG or PNG file.")
        return
      }
      
      console.log(acceptedFiles[0])
      setAttachmentFile(acceptedFiles[0])
      setImagePreview(URL.createObjectURL(acceptedFiles[0]))
    }
  }


  const renderDropzone = () =>{
    return (
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <div
              {...getRootProps()}
              className={classNames("dropzone", "person-create-dropzone-header", {
                "dropzone--isActive": isDragActive
              })}
            >
              <input {...getInputProps()} required/>
                {imagePreview ? (
                  <div className="item-form-dropzone-fallback">
                  <img src={imagePreview} className="drop-section-preview"/>
                  </div>
                ) 
                : (
                  <div className="item-form-dropzone-fallback">
                    <h3>Drop a File or Click to Add an Image&nbsp;</h3>
                  </div>
                )}
            </div>
          );
        }}
      </Dropzone>
    )
  }

  useEffect(() => {
    setImagePreview(itemImage ? itemImage.image : "")
    setAttachmentFile(null)
  }, [itemImage, open])

  const [ croppingImage, setCroppingImage ] = useState(false)

  const renderButtons = () => {
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onClose)}
        {!(itemImage && itemImage.id) && (
          renderButton("Crop", ()=>{
            setIsCropping(true)
          }, {color:"primary", disabled: submitting || !imagePreview})
        )}
        {renderButton("Save", handleSave, {color:"green", disabled: isSubmitDisabled()})}
      </Stack>
    )
  }

  const isSubmitDisabled = () => {
    if(submitting) return true
    return !attachmentFile
  }
  
  const handleSave = () => {
    if(submitting) return
    setSubmitting(true)
    const formData = new FormData()
    formData.append("item_image[item_id]", item.id)
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    if(attachmentFile){
      formData.append("item_image[image]", attachmentFile)
    }
    if(!isEditing) {
      formData.append("item_image[order]", currentImageCount)
    }
    fetch(isEditing ? `/webapi/images/${itemImage.id}` : `/webapi/images`, {
      method: isEditing ? "PATCH" : "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": token
      }
    }).then(response => {
      return response.json()
    }).then(json => {
      setSubmitting(false)
      onSave()
    })
  }



  const renderCropper = () => {
    return (
      <div>
        <Cropper
          style={{ height: "250px", width: "100%" }}
          preview=".img-preview"
          guides={false}
          src={imagePreview}
          ref={cropper}
          viewMode={1}
          dragMode="move"
          cropBoxMovable={true}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
          {renderCancelButton("Cancel", ()=>{
            setIsCropping(false)
          })}
          {renderButton("Crop Image", ()=>{
            cropImage()
          }, {color:"green"})}
        </Stack>
      </div>
    )
  }

  const cropImage = async () => {
    if(cropper){
      const currentCropper = cropper.current?.cropper;
      currentCropper.getCroppedCanvas().toBlob(async(blob) => {
        setIsCropping(false)

        setImagePreview(URL.createObjectURL(blob))
        let dataURL = URL.createObjectURL(blob)
        let blob2 = await dataURItoBlob(dataURL, "image.png");
        setAttachmentFile(blob2)
        console.log({
          blob, blob2
        })
      }, "image/png", 1)
    }
  }
  
  return (
    <Modal
      className="react-modal add-form-modal add-custom-field-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={onClose}
      contentLabel="Add An Image"
    >
       <div class="text-emerald-900 text-xl font-medium font-['Roboto'] pb-4">{isEditing ? "Replace Image" : "Upload Image"}</div>
       {isCropping && imagePreview ? (
        <>
          {renderCropper()}
        </>
       ): (
         <>
          {renderDropzone()}
          {renderButtons()}
         </>
       )}

    </Modal>
  )
}

export default ItemImageModal


const WebPDecodeAndDraw = function (data) {
    var decoder = new WebPDecoder();

    var bitmap = decoder.WebPDecode(data, data.length);

    if (bitmap) {
                //Draw Image
      var output = ctx.createImageData(canvas.width, canvas.height);
      var biWidth = canvas.width;
      var outputData = output.data;
      for (var h=0;h<canvas.height;h++) {
        for (var w=0;w<canvas.width;w++) {
          outputData[0+w*4+(biWidth*4)*h] = bitmap[0+w*4+(biWidth*4)*h];
          outputData[1+w*4+(biWidth*4)*h] = bitmap[1+w*4+(biWidth*4)*h];
          outputData[2+w*4+(biWidth*4)*h] = bitmap[2+w*4+(biWidth*4)*h];
          outputData[3+w*4+(biWidth*4)*h] = bitmap[3+w*4+(biWidth*4)*h];
        };
      }
                     
      ctx.putImageData(output, 0, 0); 
                    
      var dataURL = canvas.toDataURL("image/png");
                
      document.getElementById("dec").src=dataURL;

    }
  };  